var React = require('react');

function Education (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFD600","d":"M14.328 14.709h7.7c1.1 0 2 .9 2 2v20.4c0 1.1-.9 2-2 2h-7.7c-1.1 0-2-.9-2-2v-20.4c0-1.1.9-2 2-2Z","key":0}),React.createElement("path",{"fill":"#2D2D2D","fillRule":"evenodd","d":"M1.5 47.85a.5.5 0 0 1 .5-.5h46a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5ZM24.981 5.644a.5.5 0 0 1 .456 0l22.501 11.51a.5.5 0 0 1 0 .89l-2.794 1.43v12.525a.5.5 0 1 1-1 0V19.985l-3.764 1.926v10.288a.5.5 0 0 1-.272.445l-14.671 7.513a.5.5 0 0 1-.456 0L10.3 32.644a.5.5 0 0 1-.273-.445V21.91l-7.558-3.865a.5.5 0 0 1 0-.89l12.147-6.203a.5.5 0 1 1 .455.89L3.794 17.6 25.21 28.548l21.404-10.949L25.209 6.651 20.92 8.845a.5.5 0 1 1-.456-.89l4.517-2.311Zm.456 23.91 13.943-7.132v9.472L25.209 39.15l-14.183-7.256V22.42l13.955 7.135a.5.5 0 0 0 .456 0Z","clipRule":"evenodd","key":1})]);
}

Education.defaultProps = {"fill":"none","viewBox":"0 0 50 50"};

module.exports = Education;

Education.default = Education;
